import { createApp } from 'vue';
import ShareView from '../../love/ShareView.vue'
const appElements = document.querySelectorAll('.vue-love-share-view')

Array.from(appElements).forEach(element => {
    createApp(ShareView).mount(element);
});